import React from "react";
import "../../styles/pages/_home.css";

import HB1 from "../../assets/images/HB1.png";

export default function HeroBanner() {
  return (
    <section
      className="hero-banner"
      style={{
        backgroundImage: `url(${HB1})`
      }}
    >
      <div className="hero-overlay"></div>

<div className="hero-light"></div>

<div className="hero-content">
  

  <h1 className="hero-title">
    Building <span>Tomorrow's</span>
    <br />
    Businesses Today
  </h1>
<div className="hero-tagline">
    Where People, Technology & Strategy Converge
  </div>
  <div className="hero-actions">
    <a href="/contact" className="hero-btn hero-btn-primary">
      Let's Connect
    </a>
  </div>
</div>
    </section>
  );
}